module.exports = __webpack_public_path__ + "static/media/burka.46792e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/burka.jpg
// module id = 443
// module chunks = 0